module.exports = __webpack_public_path__ + "img/conectar.d8e4a826.png";